import React, {useState, useEffect} from 'react'
import {useList} from 'store/list'
import * as Icons from 'react-feather';

export default function ListSearch(props) {

   const WAIT_INTERVAL = 1000;
   const ENTER_KEY = 13;
   const {getList, dispatch, loading} = useList();
   let timer;

   const triggerSearch = (key) => {
      props.search(key)
   }

   const handleSearch = (e) => {
      clearTimeout(timer);
      timer = setTimeout(() => {
         triggerSearch(e.target.value)
      }, WAIT_INTERVAL);
   }

   return (<>
      <div className="w-full sm:w-auto mt-3 sm:mt-0 sm:ml-auto md:ml-0">
         <div className="w-56 relative text-gray-700 dark:text-gray-300 mt-6">
            <input onChange={handleSearch} type="search"  {...loading && 'disabled'}
                   className="form-control w-56 box pl-10 placeholder-theme-13" placeholder="جستجو..."/>
            <Icons.Search className="w-4 h-4 absolute my-auto inset-y-0 ml-3 left-0"/>
         </div>
      </div>
   </>)
}